'use client';

import type { SourceAccount, RestoreAccount, Account } from '@repo/api-gw-sdk';
import { useCallback } from 'react';
import semver from 'semver';

import { useFeatureFlags } from '@/contexts/useFeatureFlags';

import { getAccountInstalledVersion } from './roles';

export const useIsAccountFeatureSupported = () => {
  const { ManualPermissionsSetup } = useFeatureFlags();

  return useCallback(
    (
      featureVersion: string,
      account: Account | SourceAccount | RestoreAccount
    ): boolean => {
      if (ManualPermissionsSetup) {
        return true;
      }
      const version = getAccountInstalledVersion(account);
      return Boolean(isFeatureSupported(featureVersion, version));
    },
    [ManualPermissionsSetup]
  );
};

const isFeatureSupported = (
  featureVersion: string,
  installedVersion?: string
) => {
  return (
    installedVersion &&
    semver.valid(installedVersion) &&
    semver.gte(installedVersion, featureVersion)
  );
};
